<div mat-dialog-title class="dialog-header aum-typo-headline-3">
    <div class="dialog-title">{{ titleLocalizationKey | i18next }}</div>

    <div class="close-dialog">
        <mat-dialog-actions>
            <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
        </mat-dialog-actions>
    </div>
</div>

<div mat-dialog-content>
    <div *ngIf="contentMessage != null && !isContentHtmlType">{{ contentMessage | i18next }}</div>
    <div *ngIf="contentMessage != null && isContentHtmlType" [innerHTML]="contentMessage"></div>
</div>
